import React from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import { getFramework, ResourceThumbnail } from '@/framework';
import { getLocaleStore } from '@/i18n/index';
import { base64Kit } from '@/utils/base64-kit';
import type { ILayerBehavior, ILayerProps, ITableLayer, ITableLayerProps } from '@/version-types';
import { EdgelessTableLayer } from '../edgeless-layer';
import { TableLayerLoading } from '../loading';

type Behaviors = Pick<
    ILayerBehavior,
    'getEdgelessObject' | 'previewToImage' | 'getMenuOverlapName' | 'getMenuOverlapIcon' | 'customLoading'
>;

export const createRendererBehaviors = (frameworkIdentity: string) => {
    const behaviors: Behaviors = {
        getEdgelessObject(layer: ILayerProps) {
            return new EdgelessTableLayer(layer.id, getFramework(frameworkIdentity));
        },

        previewToImage: () => false,

        customLoading(layer) {
            return <TableLayerLoading layer={layer as ITableLayer} />;
        },

        getMenuOverlapName() {
            const { $t } = getLocaleStore();
            return $t((v) => v.layers.table);
        },

        getMenuOverlapIcon(layer) {
            if (layer.width <= 0 || layer.height <= 0) {
                return <IconFont name="TabulationBold" fontSize={16} />;
            }

            const resource = getFramework(frameworkIdentity).service.edgelessCanvas.getByLayerId(layer.id)?.resource;
            const { screenshotUrl: tableScreenshotUrl } = layer.data as ITableLayerProps;
            return (
                <ResourceThumbnail
                    resource={resource}
                    fallbackIcon={<IconFont name="TabulationBold" fontSize={16} />}
                    fallbackUrl={tableScreenshotUrl ? base64Kit.getLocalUrl(tableScreenshotUrl) : null}
                />
            );
        },
    };

    return behaviors;
};
